import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { forceHttps } from '@core/configs/global-functions';
import { setAngelPalleteColors } from '@core/utils/primeNg-utils';
import { TranslateService } from '@ngx-translate/core';
import { SessionStorageService } from 'ngx-webstorage';
import { of } from 'rxjs';
import { FontAwesomeService } from './font-awesome/font-awesome.service';
import { HostRouteConfigService } from './host-route-map/host-route-config.service';
import { TranslationUpdateService } from './translation/translation-update.service';


@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private config: any;

  private http: HttpClient = undefined!;
  private translateService: TranslateService = undefined!;
  private sessionStorage: SessionStorageService = undefined!;
  private translationUpdateService: TranslationUpdateService = undefined!;
  private hostRouteConfigService: HostRouteConfigService = undefined!;
  private fontAwesomeService: FontAwesomeService = undefined!;

  constructor(

  ) { }

  // entry point to load config
  async loadConfig(data: any): Promise<any> {

    const { http, translateService, sessionStorage, translationUpdateService, hostRouteConfigService, fontAwesomeService } = data;

    this.http = http;
    this.translateService = translateService;
    this.sessionStorage = sessionStorage;
    this.translationUpdateService = translationUpdateService;
    this.hostRouteConfigService = hostRouteConfigService;
    this.fontAwesomeService = fontAwesomeService;

    try {

      await this.configRoutes();
      await this.populateTenants();
      await this.configTranslate();
      await this.configFontAwesome();
      await this.configTheme();

    } catch (error) {

      return of(null); // evita quebrar o bootstrap

    }

    return of(null); // evita quebrar o bootstrap


    // return this.http.get('/assets/config.json').pipe(
    //   tap((data) => {
    //     this.config = data;
    //     console.log('✔ Config carregada:', this.config);
    //   }),
    //   catchError((error) => {
    //     console.error('❌ Erro ao carregar config:', error);
    //     return of(null); // evita quebrar o bootstrap
    //   })
    // );


  }

  getConfig() {
    return this.config;
  }


  // Configura as rotas dinâmicas de host
  /* *************************************************************** */
  async configRoutes() {

    console.log("========== Configurando rotas.");

    try {

      forceHttps(); // força https em produção

      // deprecated: carregamento síncrono instead
      //await this.hostRouteConfigService.load();

    } catch (error) {
      console.error("❌ Erro ao configurar rotas:", error);
    }


    console.log("========== Rotas configuradas.");


  }
  /* *************************************************************** */


  // populate Tenants from CDN
  /* *************************************************************** */
  async populateTenants() {

    console.log("========== Populando Tenants.");

    try {

      //espera 500ms para garantir que o CDN esteja disponível
      // await new Promise(resolve => setTimeout(resolve, 500));

      //TODO: Trocar CDN por uma API que retorne os tenants
      //const tenantList = await firstValueFrom(this.http.get<string[]>("https://aditekbox.s3.sa-east-1.amazonaws.com/CDN/tenant-list.json"));


      //espera 500ms para garantir que o CDN esteja disponível
      // await new Promise(resolve => setTimeout(resolve, 500));

      //console.log(tenantList);

      // if (tenantList && tenantList.length && tenantList.length > 0) {
      //   for (const t of tenantList) {
      //     Tenant[t] = t;
      //   }
      // }

    } catch (error) {
      console.error("❌ Erro ao popular tenants1:", error);
    }


    console.log("========== Tenants populados.");



  }
  /* *************************************************************** */


  // populate Tenants from CDN
  /* *************************************************************** */
  async configTranslate() {

    console.log("========== Configurando Translation.");

    try {


      // const browserLang = this.translateService.getBrowserLang()?.toLowerCase() || 'pt';
      // this.sessionStorage.store('agentLang', browserLang);
      // this.translateService.addLangs(['pt', 'en', 'es']);
      // this.translateService.setDefaultLang('en'); //info: se deichar direto pt, não muda para outras linguas. bug?
      // this.translateService.use(browserLang.match(/pt|en|es/) ? browserLang : 'pt'); // the lang to use, if the lang isn't available, it will use the current loader to get them

      // const version = await firstValueFrom(this.translateService.get('version'), { defaultValue: '' });
      // console.log(version);


      // console.log("========== Translation v" + version);

      const browserLang = this.translateService.getBrowserLang()?.toLowerCase() ?? (navigator.language?.split('-')[0] || 'pt');
      this.sessionStorage.store('agentLang', browserLang);
      this.translateService.addLangs(['pt', 'en', 'es']);
      await this.translationUpdateService.ensureLatest(browserLang);       // 1) Atualiza IndexedDB se houver versão remota mais nova
      this.translateService.setFallbackLang(browserLang); // 2) Inicializa ngx-translate (vai ler IndexedDB ou assets)
      await this.translateService.use(browserLang).toPromise();


    } catch (error) {

    }

    console.log("========== Translation configurado.");

  }
  /* *************************************************************** */


  // Configura as rotas dinâmicas de host
  /* *************************************************************** */
  async configFontAwesome() {

    console.log("========== Configurando FontAwesome.");

    try {

      await this.fontAwesomeService.load();

    } catch (error) {
      console.error("❌ Erro ao configurar FontAwesome:", error);
    }


    console.log("========== FontAwesome configurado.");


  }

  async configTheme() {

    console.log("========== Configurando Tema.");

    setAngelPalleteColors();

    console.log("========== Tema configurado.");
  }
  /* *************************************************************** */







}
